import moment from "moment"

const STATUS_CHOICES = {
    S: 'Submitted',
    A: 'Approved',
    H: 'Shipped'
}


export function createEquipmentRequestCards(job) {

    let cards = []

    job.jobEquipmentRequests.forEach(request => {

        cards.push({
            id: request.id,
            date: moment(request.datetimeCreated).isValid() ? moment(request.datetimeCreated).format("MM/DD/YYYY") : null,
            status: STATUS_CHOICES[request.status],
            numItems: request.equipmentRequestItemsForEquipmentRequest.length
        })
    })
    return cards
}